module.exports = __webpack_public_path__ + "img/Baisc_perc_numbers-300x128.0aa876fd.png";